var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { call, cancelled, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import download from 'downloadjs';
import { convertFiltersToSearchApiRequest } from './helpers/filtersHelpers';
import { parseTemplateWithData } from 'src/redux/cases/helpers/parseTemplateWithData';
import { deepMergeObj, getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { parseISOToDate } from 'src/shared/helpers/dateHelpers';
import { getHistoryEventType } from 'src/redux/cases/helpers/historyHelpers';
import { extractFilesUrlsToCaseDetails, extractFilesUrlsToDownloadContractCase, } from 'src/redux/cases/helpers/fileUrlsHelpers';
import { E_REQUEST_METHOD } from 'src/services/ServicesHelpers';
import { casesServices } from 'src/services/cases/casesServices';
import { sagasCreator } from 'src/redux/helpers/sagasCreators';
import { coreActions } from 'src/redux/core/coreActions';
import { casesActions } from './casesActions';
import { getCoreState, getFileUrls, getI18n, getRealm, getUrlConfigs } from '../core/coreSelectors';
import { getAllColumns, getAutoPlay, getCaseContracts, getCurrentApplicant, getCurrentCaseActionModalContent, getCurrentCaseApplicants, getCurrentCaseDocuments, getCurrentCaseHardData, getCurrentTemplate, getFilters, getModalCache, getNotificationsActivated, getTotalCases, } from './casesSelectors';
import { parseQPCCaseDetailsKYC } from 'src/redux/cases/helpers/qpcConverter';
import { parseGCPCaseDetails } from 'src/redux/cases/helpers/gcpConverter';
import { E_HISTORY_EVENT_TYPE } from 'src/redux/cases/types/casesTypes';
import { E_SNACKBAR_TYPE } from 'src/ui/components/SnackBar/SnackBar';
import { E_CASES_ACTION_TYPES } from './actionTypes';
import { E_HOST } from 'src/shared/helpers/urlHelpers';
import { keepUpdatedDocumentDataOfApplicants, parseCaseActions, reformatContractsBundle, } from 'src/redux/cases/helpers/caseHelpers';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
import { parseModalCaseAction, prepareActionModalForConfirmation } from 'src/redux/cases/helpers/caseActionModalHelpers';
import { E_CASE_ACTION_TASK } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/modals/constants';
import { changeFavicon, changeTabTitle } from 'src/shared/helpers/pagesHelpers';
import { KeycloakEntity } from 'src/shared/KeycloakEntity';
import { saveInLocalStorage } from 'src/shared/helpers/storageHelpers';
import { ERROR_CODE } from 'src/services/constants';
import { E_STATUS } from 'src/shared/types';
import { getUserInfo } from 'src/redux/auth/authSelectors';
import { parseQPCDocumentsElements } from 'src/redux/cases/helpers/qpcConverter2';
function fetchCases() {
    var urlConfig, realm, env, filters, userInfo, isAutoPlay, isNotificationsActivated, searchRequest, callAPI, _a, payload, status, error, errorMessage, i18n, tabTitle, payloadHaveContent, collectionParsed;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getUrlConfigs)];
            case 1:
                urlConfig = _b.sent();
                realm = urlConfig.realm, env = urlConfig.env;
                return [4 /*yield*/, select(getFilters)];
            case 2:
                filters = _b.sent();
                return [4 /*yield*/, select(getUserInfo)];
            case 3:
                userInfo = _b.sent();
                return [4 /*yield*/, select(getAutoPlay)
                    // Don't trigger fetch in cases view, should be done in auto-search view
                ];
            case 4:
                isAutoPlay = _b.sent();
                // Don't trigger fetch in cases view, should be done in auto-search view
                if (isAutoPlay) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getNotificationsActivated)];
            case 5:
                isNotificationsActivated = _b.sent();
                return [4 /*yield*/, put(casesActions.updateCasesCollectionLoading(true))];
            case 6:
                _b.sent();
                searchRequest = convertFiltersToSearchApiRequest(filters, userInfo);
                return [4 /*yield*/, call(function () { return casesServices.fetchCases(realm, searchRequest); })];
            case 7:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 8:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                return [4 /*yield*/, select(getI18n)];
            case 9:
                i18n = _b.sent();
                tabTitle = getPropsByKeyPath(i18n.keyValueMap, 'notifications.tabNewCases')
                    .replace('$nbDossier', "".concat(isNotificationsActivated ? '(' + ((payload === null || payload === void 0 ? void 0 : payload.total) || 0) + ')' : ''))
                    .replace('$orga', realm)
                    .replace('$env', env)
                    .toUpperCase();
                if (!(error || !payload)) return [3 /*break*/, 13];
                if (!isNotificationsActivated) return [3 /*break*/, 11];
                return [4 /*yield*/, put(coreActions.addNotificationRequested({
                        type: E_SNACKBAR_TYPE.ERROR,
                        description: getPropsByKeyPath(i18n.keyValueMap, 'notifications.error.default'),
                        withNotification: true,
                    }))];
            case 10:
                _b.sent();
                changeFavicon('/images/favicon-red.png');
                return [3 /*break*/, 12];
            case 11:
                changeFavicon('/images/favicon.png');
                _b.label = 12;
            case 12: return [3 /*break*/, 20];
            case 13:
                if (!isNotificationsActivated) return [3 /*break*/, 17];
                payloadHaveContent = payload.resultList.length > 0;
                if (!payloadHaveContent) return [3 /*break*/, 15];
                return [4 /*yield*/, put(coreActions.addNotificationRequested({
                        type: E_SNACKBAR_TYPE.INFO,
                        description: getPropsByKeyPath(i18n.keyValueMap, 'notifications.newCases'),
                        withNotification: true,
                    }))];
            case 14:
                _b.sent();
                changeFavicon('/images/favicon-green.png');
                return [3 /*break*/, 16];
            case 15:
                changeFavicon('/images/favicon-orange.png');
                _b.label = 16;
            case 16: return [3 /*break*/, 18];
            case 17:
                changeFavicon('/images/favicon.png');
                _b.label = 18;
            case 18:
                collectionParsed = { collectionResults: payload.resultList, total: payload.total };
                return [4 /*yield*/, put(casesActions.fetchCasesSucceeded(collectionParsed))];
            case 19:
                _b.sent();
                _b.label = 20;
            case 20:
                changeTabTitle(tabTitle);
                return [4 /*yield*/, put(casesActions.updateCasesCollectionLoading(false))];
            case 21:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function fetchAutoSearch() {
    var urlConfig, realm, callAPI, _a, payload, error, errorMessage, collectionParsed;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, put(casesActions.updateCasesCollectionLoading(true))];
            case 1:
                _b.sent();
                return [4 /*yield*/, select(getUrlConfigs)];
            case 2:
                urlConfig = _b.sent();
                realm = urlConfig.realm;
                return [4 /*yield*/, call(function () { return casesServices.fetchAutoSearch(realm); })];
            case 3:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 4:
                _a = _b.sent(), payload = _a.payload, error = _a.error, errorMessage = _a.errorMessage;
                if (!(!error && payload)) return [3 /*break*/, 6];
                collectionParsed = { collectionResults: payload.resultList, total: payload.total };
                return [4 /*yield*/, put(casesActions.fetchAutoSearchSucceeded(collectionParsed))];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(casesActions.fetchAutoSearchSucceeded({ collectionResults: [], total: 0 }))];
            case 7:
                _b.sent();
                console.error('An error occurred : ', errorMessage);
                _b.label = 8;
            case 8: return [4 /*yield*/, put(casesActions.updateCasesCollectionLoading(false))];
            case 9:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function updateTemplate(action) {
    var template, caseToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                template = action.template, caseToken = action.caseToken;
                //If last fetch still running we cancel it
                return [4 /*yield*/, put(casesActions.fetchCurrentCaseDetailsCancelled())];
            case 1:
                //If last fetch still running we cancel it
                _a.sent();
                return [4 /*yield*/, put(casesActions.resetModalCache())];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(casesActions.updateTemplateSucceeded(template))
                    // Parfois l'evenement update n'est pas trigger au premier rendu, vérifier pourquoi si c'est un bug il faut fixer niveau back
                    // sinon il faut cancel ici pour eviter le double fetch de case details
                    // Soit disant normal je ne suis pas d'accord avec le choix technique back
                ];
            case 3:
                _a.sent();
                // Parfois l'evenement update n'est pas trigger au premier rendu, vérifier pourquoi si c'est un bug il faut fixer niveau back
                // sinon il faut cancel ici pour eviter le double fetch de case details
                // Soit disant normal je ne suis pas d'accord avec le choix technique back
                return [4 /*yield*/, put(casesActions.fetchCurrentCaseDetailsRequested(caseToken))];
            case 4:
                // Parfois l'evenement update n'est pas trigger au premier rendu, vérifier pourquoi si c'est un bug il faut fixer niveau back
                // sinon il faut cancel ici pour eviter le double fetch de case details
                // Soit disant normal je ne suis pas d'accord avec le choix technique back
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateColumn(action) {
    var columns;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                columns = action.columns;
                return [4 /*yield*/, call(function () { return saveInLocalStorage({ columns: columns }); })];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(casesActions.updateColumnSucceeded(columns))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateDefaultColumn(action) {
    var columns;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                columns = action.columns;
                return [4 /*yield*/, put(casesActions.updateDefaultColumnSucceeded(columns))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateFilters(action) {
    var filtersState, filters;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getFilters)];
            case 1:
                filtersState = _a.sent();
                filters = action.filters;
                return [4 /*yield*/, put(casesActions.updateSearchFilterSucceeded(__assign(__assign({}, filtersState), filters)))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// TODO WARNING => difference between v4 et v5
function fetchCurrentCaseDetail(action) {
    var caseToken, realm, template, i18n, currentApplicants, _a, callAPI, abort, _b, payload, status_1, error, errorMessage, casesProcessed, documentsAndControls, kycSessions, kycVerifications, studyElementsCases, applicants, rest, isQPC, currentUserLogged, documentsByVersion, studyElements, updatedApplicants, casesEnhanced, caseDetailsFilesUrl;
    var _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                caseToken = action.caseToken;
                return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _g.sent();
                return [4 /*yield*/, select(getCurrentTemplate)];
            case 2:
                template = _g.sent();
                return [4 /*yield*/, select(getI18n)];
            case 3:
                i18n = _g.sent();
                return [4 /*yield*/, select(getCurrentCaseApplicants)
                    // Cancel previous fetch, useful when SSE trigger multiple event of update
                ];
            case 4:
                currentApplicants = _g.sent();
                // Cancel previous fetch, useful when SSE trigger multiple event of update
                return [4 /*yield*/, put(coreActions.addFilesUrlsCancelled())];
            case 5:
                // Cancel previous fetch, useful when SSE trigger multiple event of update
                _g.sent();
                return [4 /*yield*/, call(function () { return casesServices.fetchCaseDetails(realm, caseToken); })];
            case 6:
                _a = _g.sent(), callAPI = _a.callAPI, abort = _a.abort;
                _g.label = 7;
            case 7:
                _g.trys.push([7, , 14, 16]);
                return [4 /*yield*/, callAPI()];
            case 8:
                _b = _g.sent(), payload = _b.payload, status_1 = _b.status, error = _b.error, errorMessage = _b.errorMessage;
                if (!error) return [3 /*break*/, 9];
                if (status_1 === ERROR_CODE.NOT_FOUND) {
                }
                return [3 /*break*/, 12];
            case 9:
                if (!template) {
                    //console.error("No template provided, can't render the page : maybe SSE doesn't trigger page event")
                    return [2 /*return*/, null];
                }
                casesProcessed = parseTemplateWithData(payload, template, i18n);
                documentsAndControls = casesProcessed.documentsAndControls, kycSessions = casesProcessed.kycSessions, kycVerifications = casesProcessed.kycVerifications, studyElementsCases = casesProcessed.studyElements, applicants = casesProcessed.applicants, rest = __rest(casesProcessed, ["documentsAndControls", "kycSessions", "kycVerifications", "studyElements", "applicants"]);
                isQPC = !!kycSessions;
                currentUserLogged = (_c = KeycloakEntity.userInfo) === null || _c === void 0 ? void 0 : _c.preferred_username;
                documentsByVersion = isQPC
                    ? parseQPCCaseDetailsKYC(i18n, applicants, kycSessions, kycVerifications, studyElementsCases)
                    : parseGCPCaseDetails(i18n, applicants, documentsAndControls);
                studyElements = parseQPCDocumentsElements(i18n, studyElementsCases, kycSessions, kycVerifications);
                updatedApplicants = keepUpdatedDocumentDataOfApplicants(currentApplicants, applicants);
                casesEnhanced = __assign(__assign({}, rest), { kycSessions: kycSessions, documents: documentsByVersion, studyElements: studyElements, contracts: isQPC ? reformatContractsBundle(i18n, rest.contractsWidget.bundles) : [], actions: parseCaseActions(casesProcessed.actions, payload), applicants: updatedApplicants, casesProcessed: casesProcessed, lock: {
                        lockedBy: (_d = payload.currentLock) === null || _d === void 0 ? void 0 : _d.username,
                        isLocked: !!((_e = payload.currentLock) === null || _e === void 0 ? void 0 : _e.username) && ((_f = payload.currentLock) === null || _f === void 0 ? void 0 : _f.username) !== currentUserLogged,
                    } });
                return [4 /*yield*/, put(casesActions.fetchCurrentCaseDetailsSucceeded(casesEnhanced, payload))
                    // Run file fetch outside case details data, otherwise the display is blocked
                ];
            case 10:
                _g.sent();
                caseDetailsFilesUrl = extractFilesUrlsToCaseDetails(casesEnhanced);
                // update a filesUrls state which is dedicated to downloading files
                return [4 /*yield*/, put(coreActions.addFilesUrlsRequested(caseDetailsFilesUrl, true))];
            case 11:
                // update a filesUrls state which is dedicated to downloading files
                _g.sent();
                _g.label = 12;
            case 12: return [4 /*yield*/, put(casesActions.updateCurrentCaseLoading(false))];
            case 13:
                _g.sent();
                return [3 /*break*/, 16];
            case 14: return [4 /*yield*/, cancelled()];
            case 15:
                if (_g.sent()) {
                    abort();
                }
                return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}
function exportCasesInCSV() {
    var realm, allColumnConfig, filters, totalCases, userInfo, searchRequest, columnsParsed, queries, callAPI, _a, payload, status, error, errorMessage, headers, contentDispositionHeader, contentTypeHeader, fileName, mimeType;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, select(getAllColumns)];
            case 2:
                allColumnConfig = _b.sent();
                return [4 /*yield*/, select(getFilters)];
            case 3:
                filters = _b.sent();
                return [4 /*yield*/, select(getTotalCases)];
            case 4:
                totalCases = _b.sent();
                return [4 /*yield*/, select(getUserInfo)];
            case 5:
                userInfo = _b.sent();
                return [4 /*yield*/, put(casesActions.updateCasesExportLoading(true))];
            case 6:
                _b.sent();
                searchRequest = convertFiltersToSearchApiRequest(filters, userInfo);
                columnsParsed = allColumnConfig.reduce(function (acc, col) {
                    if (!col.keyMapForValue) {
                        return acc;
                    }
                    var sourcesParsed = col.keyMapForValue.map(function (item) { return ({ source: item.source.replace('data.', '') }); });
                    return __spreadArray(__spreadArray([], acc, true), [{ label: col.label, sources: sourcesParsed }], false);
                }, []);
                queries = { columns: columnsParsed, request: __assign(__assign({}, searchRequest), { count: totalCases }) };
                return [4 /*yield*/, call(function () { return casesServices.exportCasesInCSV(realm, queries); })];
            case 7:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 8:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage, headers = _a.headers;
                if (!error) return [3 /*break*/, 9];
                return [3 /*break*/, 12];
            case 9:
                contentDispositionHeader = headers['content-disposition'];
                contentTypeHeader = headers['content-type'];
                if (!(contentDispositionHeader && contentTypeHeader)) return [3 /*break*/, 12];
                fileName = contentDispositionHeader.split('=')[1].slice(1, -1);
                mimeType = contentTypeHeader.split(';')[0];
                return [4 /*yield*/, download("data:".concat(mimeType, ";charset=utf-8,").concat(encodeURIComponent(payload)), fileName, mimeType)];
            case 10:
                _b.sent();
                return [4 /*yield*/, put(casesActions.updateCasesExportLoading(false))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [2 /*return*/];
        }
    });
}
function updateHistory(action) {
    var historyState, history, _a, ts, typeEvent, historyEventType, historyParsed, newHistories_1, newHistories;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return state.cases.current.history.events; })];
            case 1:
                historyState = _b.sent();
                history = action.history;
                _a = history.body, ts = _a.ts, typeEvent = __rest(_a, ["ts"]);
                historyEventType = getHistoryEventType(history.body);
                historyParsed = __assign({ eventType: historyEventType, dateOfEvent: parseISOToDate(ts) }, typeEvent);
                if (!historyEventType) {
                    console.error('Type of history event not handled : ', history.body);
                    return [2 /*return*/];
                }
                // only keep start access
                if (historyEventType === E_HISTORY_EVENT_TYPE.ACCESS && typeEvent.access.type !== 'START') {
                    return [2 /*return*/];
                }
                if (!(historyEventType === E_HISTORY_EVENT_TYPE.SMS &&
                    historyState.some(function (h) { var _a; return ((_a = h.sms) === null || _a === void 0 ? void 0 : _a.id.smsId) === typeEvent.sms.id.smsId; }))) return [3 /*break*/, 3];
                newHistories_1 = historyState.map(function (h) {
                    var _a;
                    return ((_a = h.sms) === null || _a === void 0 ? void 0 : _a.id.smsId) === typeEvent.sms.id.smsId ? deepMergeObj(h, historyParsed) : h;
                });
                return [4 /*yield*/, put(casesActions.updateCurrentCaseHistorySucceeded(newHistories_1))];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                newHistories = __spreadArray([historyParsed], historyState, true);
                return [4 /*yield*/, put(casesActions.updateCurrentCaseHistorySucceeded(newHistories))];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function updateComment(action) {
    var commentsState, comment, _a, ts, content, author, newComments;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return state.cases.current.comments; })];
            case 1:
                commentsState = _b.sent();
                comment = action.comment;
                _a = comment.body, ts = _a.ts, content = _a.content, author = _a.author;
                newComments = __spreadArray(__spreadArray([], commentsState, true), [{ date: parseISOToDate(ts), text: content, author: author.username }], false);
                return [4 /*yield*/, put(casesActions.updateCurrentCaseCommentSucceeded(newComments))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function sendComment(action) {
    var comment, realm, urlConfig, productToken, isQPC, callAPI, _a, payload, status, error, errorMessage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                comment = action.comment;
                return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, select(getUrlConfigs)];
            case 2:
                urlConfig = _b.sent();
                productToken = action.productToken;
                isQPC = urlConfig.host === E_HOST.QPC;
                return [4 /*yield*/, call(function () {
                        return isQPC
                            ? casesServices.sendCommentV5(realm, productToken, { comment: comment })
                            : casesServices.sendCommentV4(realm, productToken, { comment: comment });
                    })];
            case 3:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 4:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (error) {
                    // TODO : handle error
                }
                else {
                    // not needed because SSE will send the comment back
                }
                return [2 /*return*/];
        }
    });
}
function updateLoadingDocStatus(action) {
    var documentId, isLoading, applicantIndex, applicants, documents, applicantId, documentsOfApplicant, newDocuments, newApplicantsDocuments;
    var _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                documentId = action.documentId, isLoading = action.isLoading;
                return [4 /*yield*/, select(getCurrentApplicant)];
            case 1:
                applicantIndex = _d.sent();
                return [4 /*yield*/, select(getCurrentCaseApplicants)];
            case 2:
                applicants = _d.sent();
                return [4 /*yield*/, select(getCurrentCaseDocuments)];
            case 3:
                documents = _d.sent();
                applicantId = (_b = applicants[applicantIndex]) === null || _b === void 0 ? void 0 : _b.id;
                documentsOfApplicant = ((_c = documents[applicantId]) === null || _c === void 0 ? void 0 : _c.documents) || [];
                newDocuments = documentsOfApplicant.map(function (doc) {
                    if (doc.id === documentId) {
                        return __assign(__assign({}, doc), { status: __assign(__assign({}, doc.status), { isLoading: isLoading }) });
                    }
                    return doc;
                });
                newApplicantsDocuments = __assign(__assign({}, documents), (_a = {}, _a[applicantId] = __assign(__assign({}, documents[applicantId]), { documents: newDocuments }), _a));
                return [4 /*yield*/, put(casesActions.updateDocStatusLoading(newApplicantsDocuments))];
            case 4:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function updateDocStatus(action) {
    var realm, i18n, urlConfig, productToken, document, newStatus, _a, id, label, isQPC, payloadToPostV4, payloadToPostV5, callAPI, _b, payload, status, error, errorMessage, headers, errorDescription;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _c.sent();
                return [4 /*yield*/, select(getI18n)];
            case 2:
                i18n = _c.sent();
                return [4 /*yield*/, select(getUrlConfigs)];
            case 3:
                urlConfig = _c.sent();
                productToken = action.productToken, document = action.document, newStatus = action.newStatus;
                _a = document, id = _a.id, label = _a.label;
                return [4 /*yield*/, call(function () { return updateLoadingDocStatus({ documentId: id, isLoading: true }); })];
            case 4:
                _c.sent();
                isQPC = urlConfig.host === E_HOST.QPC;
                payloadToPostV4 = {
                    documentCategoryCode: id,
                    status: newStatus,
                };
                payloadToPostV5 = {
                    elementId: id,
                    status: newStatus === E_STATUS.UNKNOWN ? 'UNKNOWN' : newStatus,
                };
                return [4 /*yield*/, call(function () {
                        return isQPC
                            ? casesServices.updateDocStatusV5(realm, productToken, payloadToPostV5)
                            : casesServices.updateDocStatusV4(realm, productToken, payloadToPostV4);
                    })];
            case 5:
                callAPI = (_c.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 6:
                _b = _c.sent(), payload = _b.payload, status = _b.status, error = _b.error, errorMessage = _b.errorMessage, headers = _b.headers;
                if (!error) return [3 /*break*/, 9];
                errorDescription = getPropsByKeyPath(i18n, 'modules.notification.globalView.errorMessage').replace('$docName', "\"".concat(label.trim(), "\""));
                console.error('An error occurred, ', errorMessage);
                return [4 /*yield*/, put(coreActions.addNotificationRequested({
                        type: E_SNACKBAR_TYPE.ERROR,
                        description: errorDescription,
                    }))];
            case 7:
                _c.sent();
                return [4 /*yield*/, call(function () { return updateLoadingDocStatus({ documentId: id, isLoading: false }); })];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
// vas servir a comprendre quoi faire avec le payload
// remplir une modale ? rediriger ? etc...
function makeCaseActionTask(action) {
    var decision, coreState, caseData, applicants, configs, i18n, _a, abort, callAPI, _b, status_2, payload, error, errorMessage, payloadProcessed, actionModalContent;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                decision = action.decision;
                return [4 /*yield*/, select(getCoreState)];
            case 1:
                coreState = _c.sent();
                return [4 /*yield*/, select(getCurrentCaseHardData)];
            case 2:
                caseData = _c.sent();
                return [4 /*yield*/, select(getCurrentCaseApplicants)];
            case 3:
                applicants = _c.sent();
                configs = coreState.configs;
                i18n = configs.i18n;
                _a = serviceCreator(E_REQUEST_METHOD.POST, decision.link, true, {
                    enableDefaultEvents: true,
                }), abort = _a.abort, callAPI = _a.callAPI;
                _c.label = 4;
            case 4:
                _c.trys.push([4, , 10, 13]);
                return [4 /*yield*/, callAPI()];
            case 5:
                _b = _c.sent(), status_2 = _b.status, payload = _b.payload, error = _b.error, errorMessage = _b.errorMessage;
                if (!error) return [3 /*break*/, 6];
                return [3 /*break*/, 9];
            case 6:
                payloadProcessed = parseTemplateWithData(caseData, payload, i18n);
                actionModalContent = parseModalCaseAction(configs, payloadProcessed, applicants);
                if (!(actionModalContent.taskType === E_CASE_ACTION_TASK.REDIRECT)) return [3 /*break*/, 7];
                window.open(actionModalContent.href, actionModalContent.target);
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, put(casesActions.updateActionModal(actionModalContent))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [3 /*break*/, 13];
            case 10: return [4 /*yield*/, cancelled()];
            case 11:
                if (_c.sent()) {
                    abort();
                }
                // Don't block next same sagas call
                return [4 /*yield*/, put(casesActions.makeCaseActionTaskCancelled())];
            case 12:
                // Don't block next same sagas call
                _c.sent();
                return [7 /*endfinally*/];
            case 13: return [2 /*return*/];
        }
    });
}
function confirmDecisionModal(action) {
    var params, actionModalContent, applicants, actionPreparedForConfirmation, _a, abort, callAPI, _b, status_3, payload, error, errorMessage;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                params = action.params;
                return [4 /*yield*/, select(getCurrentCaseActionModalContent)];
            case 1:
                actionModalContent = _d.sent();
                return [4 /*yield*/, select(getCurrentCaseApplicants)];
            case 2:
                applicants = _d.sent();
                return [4 /*yield*/, put(casesActions.updateActionModalLoading(true))];
            case 3:
                _d.sent();
                actionPreparedForConfirmation = prepareActionModalForConfirmation(applicants, actionModalContent, params);
                _a = serviceCreator(E_REQUEST_METHOD.POST, (_c = actionModalContent === null || actionModalContent === void 0 ? void 0 : actionModalContent.confirmButton) === null || _c === void 0 ? void 0 : _c.link, true, { data: actionPreparedForConfirmation, enableDefaultEvents: true }), abort = _a.abort, callAPI = _a.callAPI;
                _d.label = 4;
            case 4:
                _d.trys.push([4, , 9, 13]);
                return [4 /*yield*/, callAPI()];
            case 5:
                _b = _d.sent(), status_3 = _b.status, payload = _b.payload, error = _b.error, errorMessage = _b.errorMessage;
                if (!error) return [3 /*break*/, 6];
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(casesActions.updateActionModal(null))];
            case 7:
                _d.sent();
                _d.label = 8;
            case 8: return [3 /*break*/, 13];
            case 9: return [4 /*yield*/, put(casesActions.updateActionModalLoading(false))];
            case 10:
                _d.sent();
                return [4 /*yield*/, cancelled()];
            case 11:
                if (_d.sent()) {
                    abort();
                }
                // Don't block next same sagas call
                return [4 /*yield*/, put(casesActions.confirmDecisionModalCancelled())];
            case 12:
                // Don't block next same sagas call
                _d.sent();
                return [7 /*endfinally*/];
            case 13: return [2 /*return*/];
        }
    });
}
// TODO Adapt contracts for GCP without the bundles
function fetchContractsRequested() {
    var contractsBundles, contractsFileUrls;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCaseContracts)];
            case 1:
                contractsBundles = _a.sent();
                return [4 /*yield*/, extractFilesUrlsToDownloadContractCase(contractsBundles)];
            case 2:
                contractsFileUrls = _a.sent();
                return [4 /*yield*/, put(coreActions.addFilesUrlsRequested(contractsFileUrls))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function downloadContract(action) {
    var contract, fileUrls, fileProperties, contentTypeHeader, mimeType, payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                contract = action.contract;
                return [4 /*yield*/, select(getFileUrls)];
            case 1:
                fileUrls = _a.sent();
                fileProperties = fileUrls[contract.fileUrl];
                contentTypeHeader = fileProperties === null || fileProperties === void 0 ? void 0 : fileProperties.headers['content-type'];
                if (contentTypeHeader) {
                    mimeType = contentTypeHeader.split(';')[0];
                    payload = fileProperties.file;
                    download(payload, contract.label, mimeType);
                }
                return [2 /*return*/];
        }
    });
}
function downloadFileUrl(action) {
    var fileUrl, _a, callAPI, abort, _b, status, payload, error, errorMessage, headers, contentDispositionHeader, contentTypeHeader, fileName, mimeType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                fileUrl = action.fileUrl;
                _a = serviceCreator(E_REQUEST_METHOD.GET, fileUrl, true, {
                    params: { responseType: 'arraybuffer' },
                }), callAPI = _a.callAPI, abort = _a.abort;
                return [4 /*yield*/, callAPI()];
            case 1:
                _b = _c.sent(), status = _b.status, payload = _b.payload, error = _b.error, errorMessage = _b.errorMessage, headers = _b.headers;
                contentDispositionHeader = headers['content-disposition'];
                contentTypeHeader = headers['content-type'];
                if (contentDispositionHeader && contentTypeHeader) {
                    fileName = contentDispositionHeader.split('=')[1].slice(1, -1);
                    mimeType = contentTypeHeader.split(';')[0];
                    download(payload, fileName, mimeType);
                }
                return [2 /*return*/];
        }
    });
}
function updateModalIncompleteParams(action) {
    var incompleteParams, modalCache, newCache;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                incompleteParams = action.incompleteParams;
                return [4 /*yield*/, select(getModalCache)];
            case 1:
                modalCache = _a.sent();
                newCache = __assign(__assign({}, modalCache), { incompleteParams: incompleteParams });
                return [4 /*yield*/, put(casesActions.updateModalCache(newCache))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateMrzLines(action) {
    var mrzLines, applicants, currentApplicant, updatedApplicants;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mrzLines = action.mrzLines;
                return [4 /*yield*/, select(getCurrentCaseApplicants)];
            case 1:
                applicants = _a.sent();
                return [4 /*yield*/, select(getCurrentApplicant)];
            case 2:
                currentApplicant = _a.sent();
                updatedApplicants = applicants.map(function (applicant) {
                    if (applicant.id === currentApplicant.id) {
                        var updatedDocumentData = applicant.updatedDocumentData;
                        var currentMrzLines = updatedDocumentData === null || updatedDocumentData === void 0 ? void 0 : updatedDocumentData.mrz;
                        return __assign(__assign({}, applicant), { updatedDocumentData: __assign(__assign({}, updatedDocumentData), { mrz: __assign(__assign({}, currentMrzLines), mrzLines) }) });
                    }
                    return applicant;
                });
                return [4 /*yield*/, put(casesActions.updateMrzLinesSucceeded(updatedApplicants))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function casesSagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.FETCH_CASES_REQUESTED, fetchCases)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.FETCH_AUTO_SEARCH_REQUESTED, fetchAutoSearch)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.UPDATE_SEARCH_FILTERS_REQUESTED, updateFilters)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.FETCH_CURRENT_CASE_DETAILS_REQUESTED, fetchCurrentCaseDetail)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.UPDATE_TEMPLATE_REQUESTED, updateTemplate)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.UPDATE_COLUMN_REQUESTED, updateColumn)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.UPDATE_DEFAULT_COLUMN_REQUESTED, updateDefaultColumn)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.EXPORT_CASES_IN_CSV_REQUESTED, exportCasesInCSV)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_HISTORY_REQUESTED, updateHistory)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_COMMENT_REQUESTED, updateComment)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CASES_ACTION_TYPES.SEND_COMMENT_REQUESTED, sendComment)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CASES_ACTION_TYPES.UPDATE_DOC_STATUS_REQUESTED, updateDocStatus)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.DOWNLOAD_CONTRACT, downloadContract)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.FETCH_CONTRACTS_REQUESTED, fetchContractsRequested)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.DOWNLOAD_FILE_URL_REQUESTED, downloadFileUrl)];
            case 15:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.UPDATE_MRZ_LINES_REQUESTED, updateMrzLines)];
            case 16:
                _a.sent();
                return [4 /*yield*/, sagasCreator(E_CASES_ACTION_TYPES.MAKE_CASE_ACTION_TASK_REQUESTED, E_CASES_ACTION_TYPES.MAKE_CASE_ACTION_TASK_CANCELLED, makeCaseActionTask)];
            case 17:
                _a.sent();
                return [4 /*yield*/, sagasCreator(E_CASES_ACTION_TYPES.CONFIRM_DECISION_MODAL_REQUESTED, E_CASES_ACTION_TYPES.CONFIRM_DECISION_MODAL_CANCELLED, confirmDecisionModal)];
            case 18:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CASES_ACTION_TYPES.UPDATE_MODAL_INCOMPLETE_PARAMS, updateModalIncompleteParams)];
            case 19:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
